import { PPNDealer } from "../entities/dealer-response";

/**
 * This dealer is an explicit POC we do for Singapore.
 * All other dealers are fetched from the PPN API and should exclusively be maintained via PPN.
 * Be aware that no distance calculations are available for this case.
 */
export const porscheAtJewel: PPNDealer = {
  ppnOrgId: "porsche_at_jewel",
  id: "POC_PORSCHE_AT_JEWEL",
  name: "Porsche at Jewel",
  nameLocalized: "Porsche at Jewel",
  porschePartnerNo: null,
  address: {
    street: "78 Airport Boulevard #01-205/206",
    postalCode: "819666",
    city: "Singapore",
    state: "",
    countryCode: "SG",
  },
  facilityType: "CUSTOM",
  addressLocalized: {},
  contactDetails: {
    phoneNumber: "+65 9125 6039",
    emailAddress: "jewel@porsche.sg",
    homepage:
      "https://www.porsche.com/singapore/en/aboutporsche/porsche-at-jewel",
    contactOpeningHours: [
      { day: "SUNDAY", open: "10:00", close: "22:00" },
      { day: "MONDAY", open: "10:00", close: "22:00" },
      { day: "TUESDAY", open: "10:00", close: "22:00" },
      { day: "WEDNESDAY", open: "10:00", close: "22:00" },
      { day: "THURSDAY", open: "10:00", close: "22:00" },
      { day: "FRIDAY", open: "10:00", close: "22:00" },
      { day: "SATURDAY", open: "10:00", close: "22:00" },
    ],
  },
  market: "sg",
  coordinates: {
    latitude: 1.3601637309335255,
    longitude: 103.99004800218377,
  },
};
